import type { LocalUser } from "~/shared/types/auth";
export default defineNuxtPlugin(async () => {
  const user = useUser();
  if (import.meta.server) user.value = useRequestEvent()?.context.user ?? null;
  else user.value = (await $fetch<{ user: LocalUser | null }>("/api/auth/me")).user;
});
